// src/components/cgUpdateBanner.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFreemium } from './FreemiumContext';
import { useBranding } from 'modules/App/hooks/useBranding';

const CgUpdateBanner = () => {
  const { t } = useTranslation('common');
  const { hasExceededLimit } = useFreemium();
  const brand = useBranding();

  if (brand.key !== 'carbonglance') return null;
  if (!hasExceededLimit) return null; // Hide the banner if limit is not exceeded

  return (
    <div className="fixed top-0 w-full bg-orange-500 text-white text-center px-3 z-10 py-1">
      <p>
        {t('common:freemium.limitReachedPrefix', "You've reached your limit. Please")}
        <a
          href="/upgrade"
          className="underline font-bold hover:text-gray-200 ml-1"
        >
          {t('common:freemium.upgradeYourPlan', 'Upgrade Your Plan')}
        </a>{' '}
        {t('common:freemium.limitReachedSuffix', 'to continue using the platform.')}
      </p>
    </div>
  );
};

export default CgUpdateBanner;
